import defaultsDeep from 'lodash/defaultsDeep';
import { Options } from './axios-config';
import BaseConfig from './http.base-instance-config';

import { getAppVariable } from '@white-label-helper/get-app-variable';

const { interceptors } = BaseConfig;
const baseURL = `https://service-pii-vault.dev.relevancy.cavu-tech.com/v1`;

interface BookingInstance extends Options {
  baseURL: string | undefined;
}

const options: BookingInstance = defaultsDeep(
  {
    baseURL,
    headers: {
      Authorization: `Bearer ${getAppVariable('channel.token')}`,
    },
  },
  BaseConfig.options
);

export default {
  interceptors,
  options,
};
